import { CosmicJSClient } from "../../apis/cosmicjs-client";
import { Product } from "../../domain/help/help-entity";

const PRODUCT_OBJECT_TYPE = "products" as const;

const BUCKET = `graffer-console-contents` as const;

class ProductService extends CosmicJSClient {
  constructor() {
    super(BUCKET);
  }

  async fetchProduct(productId: string): Promise<Product | null> {
    const result = await this.fetch<Product>(
      JSON.stringify({
        type: PRODUCT_OBJECT_TYPE,
        id: productId,
      }),
      "id,slug,title",
      "-order",
    );
    return result?.objects && result.objects.length > 0
      ? result.objects[0]
      : null;
  }
}

export const productService = new ProductService();
